import { useQuery } from '@tanstack/vue-query'
import axios from 'axios'
import { oneHourInMS } from '@/composable/useDatesAndTimes'

export interface IServiceCheck {
  token: string
  url: string
  alias: string
  last_status: number
  uptime: number
  down: boolean
  down_since: string | null
  error: string | null
  last_check_at: string
  next_check_at: string
  enabled: boolean
  created_at: string
  disabled_locations: string[]
  tags: string[]
}

const getServiceStatus = async (): Promise<IServiceCheck[]> => {
  const apiKey = import.meta.env.VITE_UPDOWN_IO_API_KEY

  if (!apiKey) {
    // eslint-disable-next-line no-console
    console.error('Updown.io API key is not configured.')

    return []
  }

  const response = await axios.get<IServiceCheck[]>(`https://updown.io/api/checks?api-key=${apiKey}`)

  return response.data
}

export const useServiceStatusQuery = () =>
  useQuery({
    queryKey: ['service-status'],
    queryFn: getServiceStatus,
    staleTime: oneHourInMS,
  })
